import axios from 'axios';

export const getClientCustomPages = () => axios.get('/utils/custom_pages/client/');

export const getBackofficeCustomPages = () => axios.get('/utils/custom_pages/backoffice/');

export const getUser = () => axios.get('/user/');

export const stopImpersonate = () => axios.post(`/auth/impersonate/stop/`);
